import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {useContext} from "react";
import {ApploadContext} from "../contexts/Appload";

export const Appload = ({page}) => {
    let {loading} = useContext(ApploadContext);
    const spinnerIcon = <LoadingOutlined style={{fontSize: 48}} spin/>;
    return <Spin spinning={loading} indicator={spinnerIcon} style={{zIndex: 1045}}>{page}</Spin>
}
